import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Conf } from "../../utils";

interface IMenu {
	key: number | string;
	label: string;
	url: string;
	title: string;
	id: number;
	children?: IMenu[]
}

export interface IMain {
	btnLoading: boolean,
	dataLoading: boolean,
	open: boolean,
	open2: boolean,

	//菜单获取
	topMenu: IMenu[],
	leftMenu: IMenu[],
	topkeys: string[],
	leftKeys: string[],
	leftTitle: IMenu,
	menuLoading: boolean,
	page: number,
	pageSize: number,

	cid: number,
	checkCid: number[] | string[]
}

const initialState: IMain = {
	btnLoading: false,
	dataLoading: false,
	open: false,
	open2: false,
	//导航
	topkeys: [],
	leftKeys: [],
	topMenu: [],
	leftMenu: [],
	leftTitle: {
		key: '',
		label: '',
		url: '',
		title: '',
		id: 0,
	},
	menuLoading: false,

	//baocun
	page: 1,
	pageSize: Conf.sys.pageSize,

	//通用cid
	cid: 0,
	checkCid: [],
}

export const main = createSlice({
	name: 'main',
	initialState,
	reducers: {
		setBtnLoading: (state: IMain, actions: PayloadAction<boolean>) => {
			state.btnLoading = actions.payload
		},
		setDataLoading: (state: IMain, actions: PayloadAction<boolean>) => {
			state.dataLoading = actions.payload
		},
		setOpen: (state: IMain, actions: PayloadAction<boolean>) => {
			state.open = actions.payload
		},
		setOpen2: (state: IMain, actions: PayloadAction<boolean>) => {
			state.open2 = actions.payload
		},
		setMenuLoading: (state: IMain, actions: PayloadAction<boolean>) => {
			state.menuLoading = actions.payload
		},

		setTopMenu: (state: IMain, actions: PayloadAction<IMenu[]>) => {
			state.topMenu = actions.payload
		},
		setLeftMenu: (state: IMain, actions: PayloadAction<IMenu[]>) => {
			state.leftMenu = actions.payload
		},
		setTopKeys: (state: IMain, actions: PayloadAction<string[]>) => {
			state.topkeys = actions.payload
		},
		setLeftKeys: (state: IMain, actions: PayloadAction<string[]>) => {
			state.leftKeys = actions.payload
		},
		setLeftTitle: (state: IMain, actions: PayloadAction<IMenu>) => {
			state.leftTitle = actions.payload
		},
		setPage: (state: IMain, actions: PayloadAction<{ page: number, pageSize: number }>): any => {
			state.page = actions.payload.page
			state.pageSize = actions.payload.pageSize
		},
		setCid: (state: IMain, actions: PayloadAction<number>) => {
			state.cid = actions.payload
		},
		setCheckCid: (state: IMain, actions: PayloadAction<number[]>) => {
			state.checkCid = actions.payload
		},
	}
})

export const {
	setBtnLoading, setDataLoading, setOpen, setOpen2, setTopMenu, setLeftMenu, setTopKeys, setLeftKeys, setLeftTitle, setMenuLoading, setPage
	, setCid, setCheckCid
} = main.actions

export default main.reducer